<script>
import Cleave from 'cleave.js';

export default {
    props: {
        modelValue: String
    },
    data() {
        return {
            value: this.modelValue
        };
    },
    mounted() {
        const element = this.$refs.input;

        let prefix = "+7";

        if(typeof this.value === "number" && this.value > 0){
            prefix = this.value.toString()[0] == "7" ? "+" : "+7";
        }
        else if(typeof this.value === "string" && this.value.length > 0){
            prefix = "+";
        }


        this.cleave = new Cleave(element, {
            prefix: prefix,
            delimiters: [' (', ') ', '-', '-'],
            blocks: [2, 3, 3, 2, 2],
            numericOnly: true,
            noImmediatePrefix: true
        });

        element.addEventListener("blur", () => {
            if (element.value == "+7 (") {
                element.value = "";
                this.$emit("update:modelValue", "");
            }
        });

        /*
        element.form.addEventListener("clear", function () {
            setTimeout(function () {
                element.value = "";
            }, 50);
        });
        */

        element.addEventListener("focus", function () {

            setTimeout(function(){
                const end = element.value.length;

                element.setSelectionRange(end, end);
                element.focus();
            }, 5);

        });
    },
    methods: {
        checkValidity() {
            return this.$refs.input.checkValidity();
        },
        focus() {
            return this.$refs.input.focus();
        },
        onInput(event) {
            this.$nextTick(() => {
                const value = (event.target.value || "").substring(0, 18);
                this.value = value;
                this.$emit("update:modelValue", value);
            });
        }
    }
}
</script>

<template>
    <input ref="input" :value="value" @input="onInput"/>
</template>
